import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_SOURCES,
  RESET_SOURCES,
  RECEIVE_SYNC_HEALTH,
  RECEIVE_CONNECTIVITY,
  RECEIVE_VARIABLE,
  REMOVE_VARIABLE,
  RECEIVE_SITE_VARIABLES,
} from './actions';

const initialState = {
  sources: [],
  sourceTypes: [],
  siteVariablesIndex: {},
  injectableSourceTypes: ['elasticsearch'],
  importableSourceTypes: ['custom', 'dec'],
  syncedSourceTypes: ['dec'],
  siteLoaded: undefined,
  syncHealth: {},
  siteVariablesUpdatedAt: 0,
  sourceConnectivityTree: [],
  aggregatedConnectivity: {},
  sourcesUpdatedAt: 0,
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SOURCES: {
      return {
        ...state,
        sources: action.sources,
        sourceTypes: action.sourceTypes,
        siteVariablesIndex: action.siteVariablesIndex || state.siteVariablesIndex,
        siteLoaded: action.siteId,
        sourcesUpdatedAt: action.sourcesUpdatedAt,
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt || state.siteVariablesUpdatedAt,
      };
    }
    case RECEIVE_SYNC_HEALTH: {
      const { syncHealth, siteId } = action;

      return {
        ...state,
        syncHealth: {
          ...state.syncHealth,
          [siteId]: syncHealth,
        },
      };
    }
    case RECEIVE_VARIABLE: {
      return {
        ...state,
        siteVariablesIndex: {
          ...state.siteVariablesIndex,
          [action.variable.id]: action.variable,
        },
      };
    }
    case REMOVE_VARIABLE: {
      const varIndexCopy = { ...state.siteVariablesIndex };
      delete varIndexCopy[action.variableId];
      return {
        ...state,
        siteVariablesIndex: varIndexCopy,
      };
    }
    case RECEIVE_SITE_VARIABLES: {
      return {
        ...state,
        siteVariablesIndex: action.siteVariablesIndex,
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt,
      };
    }
    case RECEIVE_CONNECTIVITY: {
      return {
        ...state,
        sourceConnectivityTree: action.sourceConnectivityTree,
        aggregatedConnectivity: action.aggregatedConnectivity,
      };
    }
    case RESET_SOURCES:
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        sources: [],
        sourceTypes: [],
        injectableSourceTypes: ['elasticsearch'],
        importableSourceTypes: ['custom', 'dec'],
        syncedSourceTypes: ['dec'],
        siteLoaded: undefined,
        syncHealth: {},
        siteVariablesIndex: {},
        siteVariablesUpdatedAt: 0,
        sourceConnectivityTree: [],
        aggregatedConnectivity: {},
        sourcesUpdatedAt: 0,
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
